import { Item } from "~/components/glossaryBrands/types"
import { Dispatch, SetStateAction, useMemo } from "react"
import GlossaryContainerSection from "./GlossaryContainerSection"

interface GlossaryContainerProps {
  groups: Item[]
  selectedCategory: string
  valueSearch: string
  setActiveLetter: Dispatch<SetStateAction<string>>
}

const formatText = (text: string) => {
  return text
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

export default function GlossaryContainer(
  { groups, selectedCategory, valueSearch, setActiveLetter }: GlossaryContainerProps,
) {
  const list = useMemo(() => {
    const brands = groups?.filter((brand) => {
      if (selectedCategory && brand.category?.toLowerCase()?.includes(selectedCategory)) return true
      if (selectedCategory) return false

      const brandFormatted = formatText(brand.label)
      const valueFormatted = formatText(valueSearch)
      if (brandFormatted.includes(valueFormatted)) return true
    })

    const orderedSearchList = brands?.reduce((acc, brand) => {
      const letter = formatText(brand.label.charAt(0))
      const isLetter = /[a-zA-Z\u00C0-\u00FF ]+/i.test(letter)

      if (!isLetter && !acc['0-9']) return { ...acc, ['0-9']: [brand] }
      if (!isLetter && acc['0-9']) return { ...acc, ['0-9']: [...acc['0-9'], brand] }
      if (!acc[letter]) return { ...acc, [letter]: [brand] }
      if (acc[letter]) return { ...acc, [letter]: [...acc[letter], brand] }
      return acc
    }, {} as Record<string, Item[]>)

    return { ...orderedSearchList }
  }, [valueSearch, selectedCategory])

  const entriesList = Object.entries(list) as unknown as [string, Item[]][]

  return (
    <div className='intersection flex flex-col max-w-[1800px] mx-auto w-full lg:mt-5'>
      {!!entriesList?.length &&
        entriesList.map((brands) => (
          <GlossaryContainerSection
            key={brands[0]}
            brands={brands}
            hasSearch={!!valueSearch}
            onIntersecting={setActiveLetter}
          />
        ))}

      {!entriesList?.length && (
        <div className='w-full px-4 pt-16 lg:pt-11 pb-5 flex flex-col gap-5'>
          <span className='font-sans text-[#585858] text-center'>
            Sem resultados para o termo buscado.
          </span>
        </div>
      )}
    </div>
  )
}
